export const LIVING_ARRANGEMENTS = ["OWN", "RENT", "WITH_FAMILY"] as const;
export type LivingArrangement = (typeof LIVING_ARRANGEMENTS)[number];

export const LIVING_ARRANGEMENT_LABEL_VI: Record<LivingArrangement, string> = {
  OWN: "Tự sở hữu nhà",
  RENT: "Ở trọ",
  WITH_FAMILY: "Ở với gia đình",
};

export const GENDERS = ["MALE", "FEMALE", "OTHER"] as const;
export type Gender = (typeof GENDERS)[number];

export const GENDER_LABEL_VI: Record<Gender, string> = {
  MALE: "Nam",
  FEMALE: "Nữ",
  OTHER: "Khác",
};
